export default "__VITE_ASSET__CAWYymg8__"